export default {
  button: {
    style: { background: "#ef4136" },
  },
};
